Object.defineProperty(exports,"__esModule",{value:true});exports.useHasResponsiveProps=useHasResponsiveProps;function useHasResponsiveProps(props){if(props){}return false;}
//# sourceMappingURL=useHasResponsiveProps.js.map